import preventReClick from './method'


const install = function (Vue) {
  Vue.directive('preventReClick', preventReClick)
}

export default install
